module.exports = __webpack_public_path__ + "static/media/lsb-logo.22dbaff2.png";